export default __webpack_public_path__ + "5a9a49f4cc5e088062f7611640b225da.svg";